import cn from 'classnames';
import style from './expandedView.module.css';
import { useOutletContext } from 'react-router-dom';
import constant from '@components/common/globalization';
import ExpandCheckDetail from './ExpandCheckDetail';
import ExpandOrderDetailsSection from './ExpandOrderDetailsSection';
import PrintOptions from './PrintOptions';
import NotifyGuest from '../NotifyGuest/index';
import SendReceipt from '../SendReceipt/SendReceipt';
import RepostPayment from '../RepostPayment/index';

const ExpandedView = props => {
  const {
    checksRowData,
    selectedCheck,
    currency,
    suppressTipsOnFireBoard,
    setPopup,
    currentMode,
    setIsFlip,
    updateOrderStatus,
    setIsExpanded,
    setSelectedCheck,
  } = props;
  const filteredCheck = checksRowData?.find(
    check => check?.id === selectedCheck
  );

  const {
    handleExpandedRightSection,
    expandedRightSectionType,
    setPrintType,
    traceClick,
    setTraceClick,
    setExpandedRightSectionType,
    handlePrint,
    customSmsList,
    onHandleSendSms,
    receiptStatus,
    sortedCheckList,
  } = useOutletContext();

  const handleNextCheck = () => {
    const sortedIds =
      sortedCheckList?.length > 0
        ? sortedCheckList
        : checksRowData?.map(item => item.id);
    const selectedIndex = sortedIds.findIndex(id => id == selectedCheck);
    if (selectedIndex !== -1 && selectedIndex < sortedIds.length - 1) {
      setSelectedCheck(sortedIds[selectedIndex + 1]);
    }
  };

  const handlePrevCheck = () => {
    const sortedIds =
      sortedCheckList?.length > 0
        ? sortedCheckList
        : checksRowData?.map(item => item.id);
    const selectedIndex = sortedIds.findIndex(id => id == selectedCheck);

    if (selectedIndex > 0) {
      setSelectedCheck(sortedIds[selectedIndex - 1]);
    }
  };

  const ExpandedRightSectionComponent = () => {
    switch (expandedRightSectionType) {
      case constant.IS_PRINT_POPUP:
        return (
          <PrintOptions
            onPrintPress={handleExpandedRightSection}
            setPrintType={setPrintType}
            setTraceClick={setTraceClick}
            setIsExpanded={setIsExpanded}
            traceClick={traceClick}
            setExpandedRightSectionType={setExpandedRightSectionType}
            handlePrint={handlePrint}
            filteredCheck={filteredCheck}
            onClose={handleExpandedRightSection}
          />
        );
      case constant.EXPANDE_CHECK_DETAILS:
        return (
          <ExpandCheckDetail
            filteredCheck={filteredCheck}
            mode={currentMode}
            setPopup={setPopup}
            selectedCheck={selectedCheck}
            currency={currency}
            setIsFlip={setIsFlip}
            updateOrderStatus={updateOrderStatus}
            setIsExpanded={setIsExpanded}
            handleNextCheck={handleNextCheck}
            handlePrevCheck={handlePrevCheck}
            traceClick={traceClick}
          />
        );
      case constant.NOTIFY_GUEST:
        return (
          <NotifyGuest
            filteredCheck={filteredCheck}
            setPopup={setPopup}
            selectedCheck={selectedCheck}
            currency={currency}
            onClose={handleExpandedRightSection}
            customSmsList={customSmsList}
            onHandleSendSms={onHandleSendSms}
          />
        );
      case constant.RECEIPT_BTN:
        return (
          <SendReceipt
            filteredCheck={filteredCheck}
            setPopup={setPopup}
            selectedCheck={selectedCheck}
            currency={currency}
            onClose={handleExpandedRightSection}
            receiptStatus={receiptStatus}
          />
        );
      case constant.REPOST_PAYMENT:
        return (
          <RepostPayment
            filteredCheck={filteredCheck}
            setPopup={setPopup}
            selectedCheck={selectedCheck}
            currency={currency}
            onClose={handleExpandedRightSection}
            
          />
        );
      default:
        return (
          <ExpandCheckDetail
            filteredCheck={filteredCheck}
            mode={currentMode}
            setPopup={setPopup}
            selectedCheck={selectedCheck}
            currency={currency}
            setIsFlip={setIsFlip}
            updateOrderStatus={updateOrderStatus}
            setIsExpanded={setIsExpanded}
            handleNextCheck={handleNextCheck}
            handlePrevCheck={handlePrevCheck}
            traceClick={traceClick}
          />
        );
    }
  };
  return (
    <div className={cn('w-100 h-100', style.pContainer)}>
      <div className={cn('w-100 h-100 d-flex', style.gapBtwContainer)}>
        <div
          className={cn(
            'h-100 flex-grow-0',
            style.leftContainerWidth,
            style.containerBgColor
          )}
        >
          <ExpandOrderDetailsSection
            filteredCheck={filteredCheck}
            currency={currency}
            suppressTipsOnFireBoard={suppressTipsOnFireBoard}
            mode={currentMode}
          />
        </div>
        <div
          className={cn(
            'h-100 flex-grow-1 d-flex flex-column',
            style.containerBgColor,
            style.rightContainer
          )}
        >
          {ExpandedRightSectionComponent()}
        </div>
      </div>
    </div>
  );
};

export default ExpandedView;
